import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import {
	HeaderUserActionsChangePassword,
	HeaderUserActionsLogout,
	HeaderUserActionsProfile,
} from '../../../../../../ReactSharedScripts/modules/header/components/HeaderUserActions';
import { TooltipLanguageCollapseItem } from './TooltipLanguageCollapseItem';
import { TooltipList } from './TooltipList';
import { mapDispatch, mapState } from './headerUserTooltipReduxMap';
import Typography from '../../../../../../ReactSharedScripts/components/Typography';
import { Avatar } from '../../../../../../ReactSharedScripts/components/Avatar/Avatar';
import { useUserPageContextState } from '../../../../../../ReactSharedScripts/modules/user';
import { useStyleContextState } from '../../../../../../ReactSharedScripts/modules/styleContext';
import { FlexGrid } from '../../../../../../ReactSharedScripts/components/FlexGrid';
import { FlexGridColumn } from '../../../../../../ReactSharedScripts/components/FlexGrid';
import { HeaderActionsProvider } from '../../../../../../ReactSharedScripts/modules/header/components/HeaderActionsProvider';
import { TooltipBtn } from '../../../../../../ReactSharedScripts/components/TooltipBtn';
import { gray } from '../../../../../../ReactSharedScripts/components/Color';
import typeUtils from '../../../../../../ReactSharedScripts/utils/type';
import { ThemeStyle } from '../../../../../../ReactSharedScripts/utils/const';
import classes from './styles/index.module.scss';
import { AngleDownSmall } from '../../../../../../ReactSharedScripts/components/Icons/AngleDownSmall';

const HeaderUserTooltip = ({ showFullName }) => {
	const { avatar, initials, formattedName, canViewProfile } = useUserPageContextState();
	const { languages, theme } = useStyleContextState();
	const collapsedLanguages = useMemo(() => {
		return languages
			.filter((x) => !x.isActive)
			.reduce((previous, current) => {
				return [
					...previous,
					{
						...current,
						name: current.name,
					},
				];
			}, []);
	}, [languages]);
	const tooltipList = useMemo(() => {
		const activeLanguage = languages.find((x) => x.isActive);
		const hasActiveLanguage = !typeUtils.isNullOrUndefined(activeLanguage);
		const menuItems = [
			{
				items: [
					<HeaderUserActionsChangePassword key='header_menu_item_change_password' />,
					<HeaderUserActionsLogout key='header_menu_item_logout' />,
				],
			},
		];

		if (hasActiveLanguage) {
			menuItems[0].items.push(
				<TooltipLanguageCollapseItem
					key={activeLanguage.languageCode}
					id={activeLanguage.languageCode}
					image={activeLanguage.icon}
					name={activeLanguage.name}
					collapsedItems={collapsedLanguages}
					theme={theme}
				/>,
			);
		}

		if (canViewProfile) {
			menuItems[0].items.unshift(<HeaderUserActionsProfile key='header_menu_item_profile' />);
		}

		return menuItems;
	}, [canViewProfile, collapsedLanguages, languages, theme]);

	const tooltipTheme = theme === ThemeStyle.Dark ? ThemeStyle.Dark : ThemeStyle.Light;

	return (
		<HeaderActionsProvider>
			<FlexGrid center>
				{showFullName && (
					<FlexGridColumn>
						<Typography
							fontSize='14px'
							color={gray[6]}
							className={classes.userFullName}
						>
							{formattedName}
						</Typography>
					</FlexGridColumn>
				)}
				<FlexGridColumn>
					<TooltipBtn
						className={classes.tooltipButton}
						tooltip={<TooltipList items={tooltipList} />}
						tooltipTheme={tooltipTheme}
						tooltipPosition='bottom'
						tooltipAlign='end'
						ariaLabel='toggle user menu'
					>
						<div className={classes.tooltipInnerButton}>
							<Avatar
								photoUrl={avatar.photoUrl}
								initials={initials}
								size='medium'
							/>
							<AngleDownSmall className={classes.userIcon} />
						</div>
					</TooltipBtn>
				</FlexGridColumn>
			</FlexGrid>
		</HeaderActionsProvider>
	);
};

export default connect(mapState, mapDispatch)(HeaderUserTooltip);
